var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessagePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4701 0.9C13.4701 0.402944 13.0672 0 12.5701 0H1.61092C1.36884 0 1.13697 0.0975213 0.96766 0.270544C0.620021 0.625807 0.626202 1.19562 0.981465 1.54326L3.60899 4.1144C3.68589 4.18965 3.72923 4.2927 3.72923 4.40029V6.99276C3.72923 7.09885 3.68709 7.20059 3.61208 7.2756L0.263604 10.6241C0.0948212 10.7929 0 11.0218 0 11.2605C0 11.7575 0.402944 12.1605 0.9 12.1605L6.521 12.16L6.52195 17.3973L6.5298 17.4946C6.5763 17.7797 6.82371 17.9973 7.12195 17.9973L7.21927 17.9894C7.50436 17.9429 7.72195 17.6955 7.72195 17.3973L7.721 12.16L13.3439 12.1605C13.5826 12.1605 13.8115 12.0657 13.9803 11.8969C14.3318 11.5454 14.3318 10.9755 13.9803 10.6241L10.6318 7.2756C10.5568 7.20059 10.5147 7.09885 10.5147 6.99276V4.39393C10.5147 4.28784 10.5568 4.1861 10.6318 4.11108L13.2065 1.5364C13.3753 1.36761 13.4701 1.13869 13.4701 0.9ZM2.34644 1.2H11.8458L9.78329 3.26255C9.48323 3.56261 9.31466 3.96958 9.31466 4.39393V6.99276C9.31466 7.41711 9.48323 7.82407 9.78329 8.12413L12.6196 10.9605H1.62426L4.46061 8.12413C4.76066 7.82407 4.92923 7.41711 4.92923 6.99276V4.40029C4.92923 3.96993 4.75586 3.55771 4.44827 3.25672L2.34644 1.2Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagePin);
export default __webpack_public_path__ + "static/media/message_pin.f36f7281ad7ea1378598e6da6265ce60.svg";
export { ForwardRef as ReactComponent };